<script setup>
import { useHead } from "@vueuse/head";
import Preloader from "@/components/App/preloader.vue";
useHead({
    title: `Продукты — Baller | Оригинальные джерси — Купить оригинальную футбольную форму онлайн, интернет-магазин`,
    meta: [
        {name: 'description', content: "Описание страницы"}
    ],
})
</script>

<script>
import ticker from "@/components/App/ticker.vue";
import headerDefault from "@/components/App/header-default/header-default.vue";
import footerDefault from "@/components/App/footer/footer.vue";
import {CommonMixin} from "@/mixins/commonMethods";
import axios from "axios";
import productImagePreview from "@/components/App/product-image-preview.vue";
import ProductFilter from "@/components/App/product-filter.vue";
import {loadImg} from "@/mixins/loadImg";

export default {
        name: 'Products',
        components: {ProductFilter, productImagePreview, ticker, headerDefault, footerDefault},
        mixins: [CommonMixin, loadImg],
        data: () => ({
            isLoading: false,
            productItems: [],
            searchText: '',
            productFilters: [],
            refScrollElem: '',
            isLoadingPage: true,
        }),
        computed: {
            setPageHeader() {
                if (this.$route.query.searchText) {
                    this.searchText = this.$route.query.searchText
                    this.$route.query.searchText = ''
                }

                if (!this.searchText) {
                    return 'Все продукты'
                } else {
                    if (this.searchText.charAt(0) === '«' && this.searchText.charAt(this.searchText.length - 1) === '»') {
                        return 'Результаты поиска: ' + this.searchText;
                    }
                    return 'Результаты поиска: «' + this.searchText + "»";
                }
            },
            preFilteredItems() {
                return this.productItems.filter(productItem =>
                    this.productFilters.every(filter => {
                        // Пропускаем правило, если defaultValue пустое или false (не применяем фильтр)
                        if (filter.defaultValue === '' || filter.defaultValue === 'Любой' || filter.defaultValue === 'Любое') return true;

                        if (filter.name === 'Команда') {
                            // Извлекаем название команды из содержимого (изначально склейка из команды и страны)
                            // let teamNameMatch = productItem[filter.name]?.match(/«([^»]+)»/) ?? []
                            let teamNameMatch = productItem[filter.name].split('(')[0].trim() ?? []
                            return teamNameMatch === filter.defaultValue;
                        }

                        if (filter.name === 'Страна') {
                            // Извлекаем название команды из содержимого (изначально склейка из команды и страны)
                            const countryNameMatch = productItem['Команда']?.match(/\(([^)]+)\)/) ?? [];

                            // Возвращаем true, если команда найдена и её имя точно такое же, как в фильтре
                            return countryNameMatch.length > 1 && (countryNameMatch[1]) === filter.defaultValue;
                        }

                        if (filter.name === 'Цена') {
                            // filter.defaultValue[0] - Минимальная цена
                            // filter.defaultValue[1] - Максимальная цена
                            if (filter.defaultValue[0] && filter.defaultValue[1]) {
                                return parseInt(productItem['Цена по скидке']) >= parseInt(filter.defaultValue[0]) && parseInt(productItem['Цена по скидке']) <= parseInt(filter.defaultValue[1]);
                            } else if (filter.defaultValue[0]) {
                                return parseInt(productItem['Цена по скидке']) >= parseInt(filter.defaultValue[0])
                            } else if (filter.defaultValue[1]) {
                                return parseInt(productItem['Цена по скидке']) <= parseInt(filter.defaultValue[1])
                            } else {
                                return true
                            }
                        }

                        if (!productItem.hasOwnProperty(filter.name)) return true;

                        // Иначе выполняем стандартную проверку наличия и точного равенства
                        return (
                            productItem.hasOwnProperty(filter.name) &&
                            productItem[filter.name] === filter.defaultValue
                        );
                    })
                )
            },
            filteredItems() {
                if (!this.searchText) {
                    return this.preFilteredItems; // Если строка пустая, возвращаем весь массив
                }

                // Фильтруем объекты по всем свойствам
                return this.preFilteredItems.filter(item => {
                    return Object.entries(item).some(([key, value]) => {
                            if (key === 'images' || key === 'imageUrl' || key === 'Автор') { // Пропускаем свойство images
                                return false;
                            }
                            return String(value).toLowerCase().includes(this.searchText.toLowerCase())
                        }
                    );
                });
            },
            sortedItems() {
                for (let filter of this.productFilters) {
                    if (filter.name === 'Сортировка') {
                        if (filter.defaultValue === 'Сначала новые') {
                            return this.filteredItems.sort((a, b) => this.convertStringToDate(b['Дата последнего изменения']).getTime() - this.convertStringToDate(a['Дата последнего изменения']).getTime())
                        } else if (filter.defaultValue === 'Сначала старые') {
                            return this.filteredItems.sort((a, b) => this.convertStringToDate(a['Дата последнего изменения']).getTime() - this.convertStringToDate(b['Дата последнего изменения']).getTime())
                        } else if (filter.defaultValue === 'Дешевле') {
                            return this.filteredItems.sort((a, b) => a['Цена по скидке'] - b['Цена по скидке'])
                        } else if (filter.defaultValue === 'Дороже') {
                            return this.filteredItems.sort((a, b) => b['Цена по скидке'] - a['Цена по скидке'])
                        } else {
                            return this.filteredItems
                        }
                    }
                }
            },
            totalItems() {
                if (this.filteredItems) return this.filteredItems.length
                return 0
            },
        },
        methods: {
            setLoading() {
                this.isLoading = true
                setTimeout(() => this.unsetLoading(), 400)
            },
            unsetLoading() {
                this.isLoading = false
            },
            setCoordsOverlayGradient() {
                this.$nextTick(function() {
                    const overlay = this.$refs.overlay
                    if (!overlay) return
                    this.$refs.overlay.style.left = parseInt(this.$refs.scrollElem.getBoundingClientRect().right) - parseInt(getComputedStyle(overlay).width) + 3 + 'px'
                    this.$refs.overlay.style.top = parseInt(this.$refs.scrollElem.getBoundingClientRect().top) + 'px'
                    this.$refs.overlay.style.height = this.$refs.scrollElem.getBoundingClientRect().height + (parseInt(getComputedStyle(this.$refs.scrollElem).paddingTop) * 2) + 'px'
                })
            },
            updateFilters(filter, newValue) {
                for (let item of this.productFilters) {
                    if (item.name === filter) {
                        item.defaultValue = newValue
                    }
                }
            },
            pageAddListener() {
                if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
                    let startY = null;

                    document.addEventListener('touchstart', event => {
                        const touch = event.touches[0];
                        startY = touch.clientY;
                        if (startY) this.setCoordsOverlayGradient()
                    });
                } else {
                    window.addEventListener('wheel', this.setCoordsOverlayGradient); // Обычный обработчик для desktop-версии
                }
            }
        },
        async mounted() {
            this.isLoadingPage = true;
            await this.$store.dispatch(`product/fetchProducts`);
            await this.$store.dispatch(`fetchTeams`);
            await this.$store.dispatch(`fetchSeasons`);
            await this.$store.dispatch(`fetchCountries`);
            await this.$store.dispatch(`fetchConditions`);
            await this.$store.dispatch(`fetchBrands`);
            this.productItems = JSON.parse(JSON.stringify(this.$store.state.product.products));

            this.loadImages();

            this.productFilters = JSON.parse(JSON.stringify(this.$store.state.product.productFilters));
            this.refScrollElem = this.$refs.scrollElem

            this.setCoordsOverlayGradient()

            window.addEventListener('resize', this.setCoordsOverlayGradient);
            this.pageAddListener()

            setTimeout(this.setCoordsOverlayGradient, 6000)

            this.isLoadingPage = false;
        },
        updated() {
            this.setCoordsOverlayGradient()
        },
        unmounted() {
            window.removeEventListener('resize', this.setCoordsOverlayGradient);
            window.removeEventListener('wheel', this.setCoordsOverlayGradient);
        },
        watch: {
            productItems(newValue) {
                if(newValue?.length > 0) {
                    this.loadImages();
                }
            }
        },
        beforeRouteLeave(to, from, next) {
            this.refScroll?.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('resize', this.setCoordsOverlayGradient);
            window.removeEventListener('scroll', this.onVerticalScrollHandler);
            window.removeEventListener('wheel', this.setCoordsOverlayGradient);
            next(); // Продолжаем переход
        },
    }
</script>

<template>
    <preloader v-if="isLoadingPage" :is-loading="isLoadingPage"></preloader>
    <ticker></ticker>
    <header-default></header-default>
    <div class="container page column-page" @scroll="setCoordsOverlayGradient">
        <div class="row">
            <div class="header-block">
                <div class="header-text">
                    <h3 class="page-header">{{ setPageHeader }}</h3>
                    <span class="totalItems" v-if="totalItems">{{ totalItems }}</span>
                </div>
            </div>
        </div>
        <div class="row product-filters-block" ref="filtersBlock">
            <div class="col-12">
                <div class="search-block" v-if="isMobile">
                    <div class="loading-icn" :style="`display: ${isLoading ? 'block' : 'none'}`">
                        <svg :display="isLoading ? 'block' : 'none' " width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 3C16.97 3 21 7.03 21 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="input-elem">
                        <input type="text" name="search" id="search" v-model="searchText" placeholder="Поиск" @input=setLoading>
                    </div>
                </div>
            </div>
            <div class="col-12 filters" ref="filters">
                <div class="left" ref="scrollElem">
                    <product-filter v-for="filter of productFilters"
                                    :name="filter.name"
                                    :type="filter.type"
                                    :icon="filter.icon"
                                    :defaultValue="filter.defaultValue"
                                    :values="filter.values || $store.state[filter.key] || false"
                                    :refScroll="refScrollElem"
                                    @update:updFilter="updateFilters"
                    >
                    </product-filter>
                </div>
                <div ref="overlay" class="overlay-gradient"></div>
                <div class="search-block" v-if="!isMobile">
                    <div class="loading-icn" :style="`display: ${isLoading ? 'block' : 'none'}`">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 3C16.97 3 21 7.03 21 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="input-elem">
                        <input type="text" v-model="searchText" placeholder="Поиск" @input=setLoading>
                    </div>
                </div>
            </div>


        </div>
        <div class="row product-items">
            <router-link :to="{ name: 'product-item', params: { code: product['Код'] } }" v-for="product of sortedItems" class="col-6 col-lg-3 col-md-3 product-item">
                <product-image-preview
                    :headerImage=setImageThumbURL(product.imageUrl)
                    :images=product.images
                    :actProduct="product"
                ></product-image-preview>
                <div class="product-text-block">
                    <h3 class="product-name">{{ product["Название продукта"] }}</h3>
                    <p class="product-size">{{ sizes[product["Размер"]] }}</p>
                    <div class="sale-block" v-if="product['Цена по скидке'] !== 0 && product['Цена по скидке'] !== product['Обычная цена']">
                        <p class="sale-price">{{ product['Цена по скидке'] }}&#8381;</p>
                        <p class="default-price">{{ product['Обычная цена'] }}&#8381;</p>
                    </div>
                    <div class="default-block" v-else>
                        <p class="sale-price">{{ product['Обычная цена'] }}&#8381;</p>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
    <footer-default></footer-default>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
    .header-block {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
    }

    .search-block {
        display: flex;
        align-items: center;
        gap: 5px;
    }

    .header-text {
        display: flex;
        align-items: flex-start;
        gap: 5px;
    }

    .header-text span.totalItems {
        font-size: 12px;
        color: $hard-gray;
    }

    .page-header {
        margin-bottom: 0;
    }

    .product-items {
        gap: 40px 0;
    }

    .product-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .product-name {
        margin-bottom: 5px;
        font-size: 18px;
        font-weight: 500;
    }

    p.product-size {
        font-family: "PT Sans";
        font-weight: 700;
        color: $hard-gray;
        font-size: 14px;
    }

    .sale-block, .default-block {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
        gap: 10px;
        text-align: center;
    }

    .sale-block * {
        text-align: center;
    }

    .sale-price {
        font-size: 22px;
        font-weight: 500;
    }

    .default-price {
        font-size: 12px;
        color: $hard-gray;
        text-decoration: line-through;
    }

    .product-filters-block {
        margin-bottom: 3%;
    }

    .filters {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        //position: relative;
    }

    .filters .left {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
        flex-grow: 1;
        height: 100%;

        padding-right: 1%;

        overflow-y: visible;
        overflow-x: auto;

        max-width: 100vw;
    }

    .filters {
        overflow-x: hidden;
        max-width: 100vw;
    }

    .left::-webkit-scrollbar {
        display: none;
    }

    .overlay-gradient {
        z-index: 3;
        width: 45px;
        position: absolute;
        top: 0;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    }

    .product-filters-block .input-elem {
        position: relative;
        z-index: 4;
    }

    @media screen and (max-width: 750px) {
        .header-block {
            flex-direction: column;
            justify-content: center;
            gap: 10px
        }

        .search-block {
            width: 100%;
        }

        .search-block .input-elem {
            width: 100%;
            border: none;
        }

        .search-block .input-elem input {
            text-align: center;
            outline: none !important;
            border: none;
            border-radius: 0;
            border-bottom: 1px solid $gray;
        }

        .page-header {
            text-align: center;
        }

        .product-filters-block {
            gap: 10px;
            margin-bottom: 25px;
        }

        .product-items {
            gap: 20px 0
        }

        .product-image {
            margin-bottom: 10px;
        }

        .product-name {
            font-size: 16px;
        }

        p.product-size {
            font-size: 12px;
        }

        .sale-block {
            flex-direction: column;
            gap: 3px
        }

        .sale-price {
            font-size: 18px;
        }

        .default-price {
            font-size: 10px;
        }
    }
</style>